import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  type: 'newsletter',
  aliases: ['newsletter'],
  slices: [{
    name: 'newsletter_subscription_form',
    path: 'Newsletter/SubscriptionForm.vue'
  }]
};